import React, { useState } from "react";
import { TiDelete } from "react-icons/ti";
interface fileUploadProps {
  errors?: any;
  required?: boolean;
  pattern?: {
    type: any;
    message: string;
  };
  selectFile?: (file: FileList | null) => void;
  imageName?: string;
  tabIndex?: number;
  refType?: React.RefObject<HTMLInputElement>;
  className?: any;
  handleClickDelete?: any;
  imageDelete?: any;
  setImageName?: any

}
export default function FormFileUpload(props: fileUploadProps) {
  const { errors, selectFile, refType, imageName, tabIndex, required, className, handleClickDelete, setImageName } = props;

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;
    if (files && selectFile) {
      selectFile(files);

    }

  };

  const[imageDelete, setImageDelete] = useState(false)
  const handleDeleteImage = () => {
    setImageDelete(true);
    setImageName("There is no image added")
  }

  return (
    <>
      <div className="mt-2 d-flex position-relative">
        <input
          type="file"
          className="position-absolute upload-file"
          ref={refType}
          onChange={handleFileChange}
          required={required}
        />
        <button
          type="button"
          className="sph-btn sph-shift rounded-pill text-nowrap fw-500"
          tabIndex={tabIndex}
          onClick={() => refType?.current?.click()}
        >
          Choose Image
        </button>
        <span className={imageName == 'There is no image added' && imageDelete==false ? "align-self-center ms-2 text-truncate upload-msg-text text-body-tertiary" : `align-self-center ms-2 text-truncate upload-msg-text text-body-tertiary  ${className}`}>
          {imageName}{imageName != 'There is no image added' ? <TiDelete className='DeleteButton ms-1' onClick={handleDeleteImage} /> : null}
        </span>
      </div>
    </>
  );
}
